module.exports = __webpack_public_path__ + "img/invite-hover.4efb475b.svg";